import { useCallback } from "react";

import { useNavigate, useSearch } from "@tanstack/react-router";

import Modal from "@gx/dls/modal/Modal";

import CreateProjectModalBody from "@/pages/projects/forms/create/components/CreateProjectModalBody";
import CreateProjectModalFooter from "@/pages/projects/forms/create/components/CreateProjectModalFooter";
import CreateProjectModalHeader from "@/pages/projects/forms/create/components/CreateProjectModalHeader";
import CreateProjectModalStep from "@/pages/projects/forms/create/components/CreateProjectModalStep";
import CreateProjectFormProvider from "@/pages/projects/forms/create/CreateProjectFormProvider";
import { useCreateProjectFormContext } from "@/pages/projects/forms/create/hooks";

interface CreateProjectModalProps {
  onClose?: () => void;
}

const CreateProjectModalContent = ({ onClose }: { onClose: () => void }) => {
  const { state } = useCreateProjectFormContext();

  return (
    <CreateProjectModalStep
      step={state.step}
      header={<CreateProjectModalHeader onClose={onClose} />}
      body={<CreateProjectModalBody />}
      footer={<CreateProjectModalFooter onClose={onClose} />}
    />
  );
};

const CreateProjectModal = ({ onClose }: CreateProjectModalProps) => {
  const { createProject } = useSearch({ from: "__root__" });
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    void navigate({
      to: ".",
      search: (prev) => ({ ...prev, createProject: undefined }),
    });
    onClose?.();
  }, [navigate, onClose]);

  const isOpen = createProject === true;

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <CreateProjectFormProvider>
        <CreateProjectModalContent onClose={handleClose} />
      </CreateProjectFormProvider>
    </Modal>
  );
};

export default CreateProjectModal;
